import styles from "../../styles/archive/Related.module.css";
import relatedSite from "../../data/relatedSite.json";
import classNames from "classnames/bind";
import { useState } from "react";

const cx = classNames.bind(styles);

export default function Related() {
  const [tab, setTab] = useState("professional");
  const professional = relatedSite.site.professionalSite;
  const news = relatedSite.site.newsSite;

  const renderSiteCard = (item, index) => (
    <div className={cx("reveal")}>
      <a
        key={index}
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
        className={cx("siteCard", "card", "liftUp")}
      >
        <div className={cx("logoBox")}>
          <img src={item.logo} alt={item.name} />
        </div>

        <div className={cx("cardContent")}>
          <h5>{item.name}</h5>
          <p>{item.desc}</p>
        </div>
        <div className={cx("arrow")}>→</div>
      </a>
    </div>
  );

  return (
    <div className={cx("siteContainer")}>
      <div className={cx("title")}>
        <h4>관련 사이트</h4>
      </div>
      <p className={cx("siteDesc")}>
        손해사정, 보험금 청구, 법령 검색, 판례 확인 등에 도움이 되는 기관 및
        전문 사이트를 안내하는 메뉴입니다.
        <br />
        고객이 신뢰할 수 있는 공공기관 및 관련 전문기관 정보를 편리하게 확인할
        수 있도록 정리할 예정입니다.
        <br />
        단순 링크 모음이 아니라, 어떤 정보를 어디서 확인할 수 있는지 함께
        안내하여 실제 활용도를 높이겠습니다.
      </p>

      <div className={cx("tabBtn")}>
        <div
          className={cx("tabInfo", { active: tab === "professional" })}
          onClick={() => setTab("professional")}
        >
          전문 사이트
        </div>

        <div
          className={cx("tabInfo", { active: tab === "news" })}
          onClick={() => setTab("news")}
        >
          뉴스 사이트
        </div>
      </div>

      <div className={cx("siteList", { hidden: tab !== "professional" })}>
        {professional.map((item, index) => renderSiteCard(item, index))}
      </div>

      <div className={cx("siteList", { hidden: tab !== "news" })}>
        {news.map((item, index) => renderSiteCard(item, index))}
      </div>
    </div>
  );
}
